import { render, staticRenderFns } from "./AlertScoring.vue?vue&type=template&id=1322ea53&"
import script from "./AlertScoring.vue?vue&type=script&lang=js&"
export * from "./AlertScoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports